(function () {
    'use strict';
    'ngInject';

    angular.module('app.ctrls').controller('TemplateProductSavedModalCtrl', templateProductSavedModalCtrl);

    function templateProductSavedModalCtrl($scope, $mdDialog, templateId, forMyProductBases) {
        $scope.templateId = templateId;
        $scope.titleSaved = 'Product Base Saved';
        $scope.isEmbedded = new URLSearchParams(window.location.search).get('embedded') === 'true';
        $scope.goToTemplateProducts = function () {
            $mdDialog.hide();
        };
        $scope.onCloseClick = function () {
            window.parent.postMessage({ source: 'customily-app', type: 'close-app-window' }, '*');
        };
    }
})();
